// sidebarHelpers.js

/**
 * Generates sidebar section definitions based on the given routes and logos.
 * @param {Array} routes - Array of route objects.
 * @param {Object} logos - Optional logo map (e.g., { dcg: dcgLogo }).
 * @returns {Array} Sidebar section configs.
 */
export const sidebarSections = [
    { id: "dcg", title: "DateCodeGenie®", abbrev: "DCG", colorClass: "nav-dcg bg-dcg" },
    //{ id: "ss", title: "StockSmart", abbrev: "SS", colorClass: "nav-ss bg-ss" },
    //{ id: "afs", title: "Always Food Safe", abbrev: "AFS",colorClass: "nav-afs bg-afs" },
    //{ id: "tb", title: "TaskBytes", abbrev: "TB", colorClass: "nav-tb bg-tb" },
    //{ id: "dp", title: "DishPatch", abbrev: "DP", colorClass: "nav-dp bg-dp" },
];
export function getSidebarSections(routes, logos = {}) {
    return sidebarSections.map((section) => ({
        ...section,
        logo: logos[section.id] ?? logos.dcg,
        routes: routes.filter((r) => r.section === section.id),
    }));
}
